import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Bones } from '../domain';
import { SkeletonBlockComponent } from '../ui-skeleton-block/skeleton-block.component';

interface BonesConfig {
  rows: string;
  cols: string;
  responsive: string;
}

@Component({
  selector: 'rma-skeleton-grid',
  template: `<div class="grid" [class]="gridClass">
    @for (item of [].constructor(bones); track $index) {
      <rma-skeleton-block [class]="heightClass" />
    }
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SkeletonBlockComponent],
})
export class SkeletonGridComponent {
  @Input()
  heightClass = 'h-12';

  @Input()
  mode: keyof BonesConfig = 'responsive';

  @Input()
  bones: Bones = 3;

  @Input()
  gapClass = 'gap-4';

  private readonly BONES_MODE_STYLE: Record<Bones, BonesConfig> = {
    1: {
      rows: 'grid-rows-1',
      cols: 'grid-cols-1',
      responsive: 'grid-rows-1 md:grid-cols-1',
    },
    2: {
      rows: 'grid-rows-2',
      cols: 'grid-cols-2',
      responsive: 'grid-rows-2 md:grid-cols-2 md:grid-rows-1',
    },
    3: {
      rows: 'grid-rows-3',
      cols: 'grid-cols-3',
      responsive: 'grid-rows-3 md:grid-cols-3 md:grid-rows-1',
    },
    4: {
      rows: 'grid-rows-4',
      cols: 'grid-cols-4',
      responsive: 'grid-rows-4 md:grid-cols-4 md:grid-rows-1',
    },
    5: {
      rows: 'grid-rows-5',
      cols: 'grid-cols-5',
      responsive: 'grid-rows-5 md:grid-cols-5 md:grid-rows-1',
    },
    6: {
      rows: 'grid-rows-6',
      cols: 'grid-cols-6',
      responsive: 'grid-rows-6 md:grid-cols-6 md:grid-rows-1',
    },
  };

  protected get gridClass() {
    return `${this.BONES_MODE_STYLE[this.bones][this.mode]} ${this.gapClass}`;
  }
}
